import { PROFILES } from "../../components/VerticalLayout/SidebarContent";

export const getDefaultRouteId = (authUser) => {
  if (PROFILES.Administrador == authUser.profile_id || PROFILES.Checador == authUser.profile_id) {
    return authUser.route_id;
  }

  if (PROFILES.Concesionario == authUser.profile_id) {
    return authUser.route_id;
  }

  return null;
};
